import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 * 未触发条件单
 */
@Component({
})
export default class OrderSearch extends Vue {

  @Prop()
  public tableData;

  public get sortedTableData() {
    const arr = Array.isArray(this.tableData) ? this.tableData.slice() : [];
    return arr.sort((a, b) => {
      const ta = a && a.insertTime ? String(a.insertTime) : '';
      const tb = b && b.insertTime ? String(b.insertTime) : '';
      return tb.localeCompare(ta);
    });
  }

  public offsetClass(offset: string) {
    if (!offset) {
      return '';
    }
    return offset.indexOf('买') !== -1 ? 'offset-buy' : 'offset-sell';
  }

  public stateClass(state: string) {
    if (!state) {
      return 'state-cancel';
    }
    if (state.indexOf('成') !== -1 && state.indexOf('未') === -1) {
      return 'state-done';
    }
    if (state.indexOf('撤') !== -1 || state.indexOf('拒') !== -1 || state.indexOf('废') !== -1) {
      return 'state-cancel';
    }
    return 'state-active';
  }
}



// WEBPACK FOOTER //
// ./src/views/TradeDetail/components/OrderSearch/OrderSearch.ts